import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../../components/header/Header';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';

const PrivacyPage = () => {
    const { t } = useTranslation();
    const rights = t('privacy.rights.items', { returnObjects: true });

    return (
        <Fragment>
            <Header hclass={'header--styleFour'} />
            <main className="main">
                <section className="privacyPage sitePageSection">
                    <div className="container">
                        <article className="privacyPage__content">
                            <div className="sitePageHeading">
                                <h1>{t('privacy.title')}</h1>
                                <p>{t('privacy.updated')}</p>
                            </div>

                            {['controller', 'scope', 'purpose', 'collection', 'transfer', 'retention', 'browser'].map((section) => (
                                <section className="privacyPage__section" key={section}>
                                    <h2>{t(`privacy.${section}.title`)}</h2>
                                    <p>{t(`privacy.${section}.text`)}</p>
                                </section>
                            ))}

                            <section className="privacyPage__section">
                                <h2>{t('privacy.rights.title')}</h2>
                                <p>{t('privacy.rights.intro')}</p>
                                <ul>
                                    {Array.isArray(rights) && rights.map((right) => <li key={right}>{right}</li>)}
                                </ul>
                            </section>

                            <section className="privacyPage__section">
                                <h2>{t('privacy.contact.title')}</h2>
                                <p>{t('privacy.contact.text')}</p>
                                <address>
                                    <strong>{t('privacy.association_name')}</strong><br />
                                    Üngüt Mahallesi 71069. Sokak Loft Apartmanı Kat: 1 No: 1,<br />
                                    Onikişubat / Kahramanmaraş<br />
                                    <a href="mailto:info@kaed.org.tr">info@kaed.org.tr</a>
                                </address>
                            </section>

                            <p className="privacyPage__note">{t('privacy.note')}</p>
                        </article>
                    </div>
                </section>
            </main>
            <Footer />
            <Scrollbar />
        </Fragment>
    );
};

export default PrivacyPage;
